import { Component } from "@angular/core";

@Component({
    templateUrl: "./hubber-pro-integration.component.html"
})
export class HubberProIntegrationComponent {

}